import { useState } from 'react';
import { useSelector } from 'react-redux';
import ClaimsReportingList from './ClaimsReportingList';
import TableTitle from '../../Shared/Table/widgets/TableTitle';
import TablePageContainer from '../../Shared/Table/widgets/TablePageContainer';

const Claims = () => {
  const { en: { titles } } = useSelector((state) => state.i18n);
  const [filterStyle, setFilterStyle] = useState(false);
  const [totalCount, setTotalCount] = useState(null);

  return <TablePageContainer>
    <ClaimsReportingList
      setFilterStyle={setFilterStyle}
      setTotalCount={setTotalCount}
      tableTitle={<TableTitle
        titleText={titles.claimsReporting}
        count={totalCount}
        countFiltered={filterStyle}
      />}
    />
  </TablePageContainer>;
};

export default Claims;
